import { render, staticRenderFns } from "./MultipleColorSet.vue?vue&type=template&id=236273c3&scoped=true&"
import script from "./MultipleColorSet.vue?vue&type=script&lang=js&"
export * from "./MultipleColorSet.vue?vue&type=script&lang=js&"
import style0 from "./MultipleColorSet.vue?vue&type=style&index=0&id=236273c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236273c3",
  null
  
)

export default component.exports